export const COLOR = Styles.color.white;
